import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialComponent } from './social';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/company.service';
import { AppDataService } from '../../services';
import { SocialListComponent } from './social-list/social-list';
import { ProfileComponent } from './profile/profile';
import { UploadComponent } from './upload/upload';
import { EasyLoginModule } from "../+easylogin/easylogin.module";
import { GameEventModule } from "../+gameevent/gameevent.module";
import { Advertising } from './advertising/advertising';
@NgModule({
  declarations: [
    SocialComponent,
    ProfileComponent,
    SocialListComponent,
    UploadComponent,
    Advertising
  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    GameEventModule,
    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,
    AppDataService


  ],
  exports: [
    SocialComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SocialModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/social/social.module.ts